import {
    Component,
    ViewContainerRef,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { SiteServices } from '../../services/siteservices';

import { ModalDialogService } from 'ngx-modal-dialog';
import { SimpleModalComponent } from 'ngx-modal-dialog';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { COPYFILE_EXCL } from 'constants';
import { isNumber } from 'util';
import { FileUploader } from 'ng2-file-upload';
import { EnvironmentServices } from '../../services/evironment.service';

@Component({
    selector: 'categoryapp',
    templateUrl: '/templates/get/Category/category',
})
export class CategoryComponent {
    current_row: any;
    current_provider: any;

    public curCat1: any = {};
    public curCat2: any = {};

    public curKeyCat: any = {};

    public newCat1: any = {};
    public newCat2: any = {};
    public newCat3: any = {};
    providerList: any;

    public errstr = '';
    pid = 'CATEGORY';
    public rootList: Array<any>;
    public curKeyList: Array<any>;

    public modalRef: BsModalRef;

    public newKey: any = null;

    isupload: boolean;
    isDeleting = false;
    countChildren = 0;
    categoryImages: any;
    public siteImagesURL = '';
    selectedCategoryToEdit: any;

    @ViewChild('cattemplate')
    private catTemplateRef: TemplateRef<any>;
    @ViewChild('editCategory')
    private editCategoryTemplateRef: TemplateRef<any>;

    /*************Uploaders************/
    public engine: any = [];
    public headerIconUploader: FileUploader;
    public MainCategoryIconFileNameIconUploader: FileUploader;
    public MainCategoryImageWhiteFileNameUploader: FileUploader;
    public MainCategoryImageBlueFileNameUploader: FileUploader;
    public CategoryImageFileNameUploader: FileUploader;
    /*************Uploaders end************/

    constructor(
        public siteServices: SiteServices,
        public viewRef: ViewContainerRef,
        public modalService: ModalDialogService,
        private bsmodalService: BsModalService,
        public _environmentServices: EnvironmentServices
    ) {
        this.siteImagesURL = this._environmentServices.getSiteImagesUrl();
        this.siteServices.provider_Execute(
            'PROVIDER',
            'GETALLPROVIDERS',
            {},
            (data) => {
                this.providerList = data.TagObject;
                console.log(this.providerList);
            }
        );

        this.siteServices.provider_Execute(
            this.pid,
            'GETROOTCATEGORYLIST',
            {},
            (data) => {
                this.rootList = data.TagObject;
            }
        );
    }

    public selCat(cat: any, curcat) {
        if (curcat.Level === 1) {
            this.curCat2 = {};
        }
        Object.assign(curcat, cat);
        this.siteServices.provider_Execute(
            this.pid,
            'GETCATEGORYBYID',
            { CategoryID: cat.CategoryID },
            (data) => {
                Object.assign(curcat, data);
                curcat.ChildList = data.TagObject.ChildList;
            }
        );
    }

    public edit(cat: any) {
        this.selectedCategoryToEdit = cat;
        this.modalRef = this.bsmodalService.show(this.editCategoryTemplateRef, {
            class: 'modal-md',
        });
    }

    public new(cat: any, level: number) {
        cat.edited = true;
        // temp bind
        cat.Parent =
            level === 1 ? null : level === 2 ? this.curCat1 : this.curCat2;
        cat.ParentCategoryID =
            cat.Parent != null ? cat.Parent.CategoryID : null;
    }

    removeImg(categName: string) {
        console.log(categName);
        this.siteServices.provider_Execute(
            'CATEGORY',
            'DELETECATEGORYPROVIDERIMAGE',
            { categName: categName },
            (data) => {
                this.categoryImages = null;
            }
        );
    }

    public save(cat: any) {
        this.siteServices.provider_Save(this.pid, cat, () => {
            this.selectedCategoryToEdit = null;
            this.siteServices.success('Mentés - OK');
        });
        
        this.modalRef.hide();
    }

    public saveNew(cat: any, level: number) {
        cat.Level = level;
        cat.Status = 'n';
        this.siteServices.provider_Save(this.pid, cat, (data) => {
            const parent = cat.Parent;
            Object.assign(cat, { CategoryName: null, edited: false });
            const dbCat = data.TagObject;
            dbCat.ChildList = [];
            dbCat.IsLeaf = level === 3;
            if (parent != null) {
                parent.ChildList.push(dbCat);
            } else {
                this.rootList.push(dbCat);
            }
            this.siteServices.success('Mentés - OK');
        });
    }

    public deleteCategoryKey(cat: any, level: number) {
        this.siteServices.provider_Delete(
            'CATEGORYKEY',
            cat.CategoryID,
            (data) => {
                console.log('[CATEGORYKEY] : Data=\n');
            }
        );
    }

    public sure(viewRef: ViewContainerRef, clbFunc: Function) {
        const actionButtons = [
            {
                text: 'igen',
                onAction: () => {
                    //cat.isDeleting = true;
                    clbFunc();
                    return true;
                },
            },
            {
                text: 'nem',
                onAction: () => {
                    return true;
                },
            },
        ];

        this.modalService.openDialog(viewRef, {
            title: 'Biztos vagy benne?',
            childComponent: SimpleModalComponent,
            actionButtons: actionButtons,
            data: { text: 'Az összes alkategóriát is töröljük...' },
        });
    }

    public statusChange(cat: any) {
        this.siteServices.provider_changeStatus(
            this.pid,
            cat.CategoryID,
            (data) => {
                this.siteServices.success('Változtatás - OK');
            }
        );
    }

    //Delete function
    public del(cat: any, level: number) {
        let answer = this.sure(this.viewRef, (x) => {
            cat.isDeleting = true;
            let count = null;
            this.siteServices.provider_Execute(
                this.pid,
                'GETCATEGORYBYID',
                { CategoryID: cat.CategoryID },
                (data) => {
                    // Get Count of Children of a current category
                    count = Object.keys(data.TagObject.ChildList).length;
                    this.countChildren = count;
                    this.siteServices.provider_GetPage(
                        {
                            FilterList: [
                                {
                                    FieldName: 'CategoryGroupID',
                                    SearchTerm: cat.CategoryID,
                                },
                            ],
                            ProviderCode: 'PRODUCT',
                            SortField: 'ProductID',
                        },
                        (pageData) => {
                            this.countChildren = count;
                            //Check if product list is empty
                            if (
                                this.countChildren !== 0 ||
                                Object.keys(pageData.TagObject).length !== 0
                            ) {
                                cat.isDeleting = false;
                                this.siteServices.error(
                                    'Please empty Childs or delete products'
                                );
                                return null;
                            } else {
                                this.siteServices.provider_Delete(
                                    this.pid,
                                    cat.CategoryID,
                                    (data) => {
                                        cat.isDeleting = false;
                                        this.siteServices.success(
                                            'Törlés - OK'
                                        );
                                        if (level === 1) {
                                            this.siteServices.delete(
                                                this.rootList,
                                                (value: any) => {
                                                    return (
                                                        value.CategoryID ===
                                                        cat.CategoryID
                                                    );
                                                }
                                            );
                                            this.curCat1 = {};
                                            this.curCat2 = {};
                                        } else {
                                            this.siteServices.delete(
                                                this['curCat' + (level - 1)]
                                                    .ChildList,
                                                (value: any) => {
                                                    return (
                                                        value.CategoryID ===
                                                        cat.CategoryID
                                                    );
                                                }
                                            );
                                            if (level === 2) {
                                                this.curCat2 = {};
                                            }
                                        }
                                    }
                                );
                            }
                        }
                    );
                }
            );
        });
    }

    public key(cat: any, template: TemplateRef<any>) {
        this.curKeyCat = cat;

        this.siteServices.provider_Execute(
            this.pid,
            'GETCATEGORYKEYS',
            { CategoryID: cat.CategoryID },
            (data) => {
                this.curKeyList = data.TagObject;
                this.newKey = null;
                this.modalRef = this.bsmodalService.show(template, {
                    class: 'modal-lg',
                });
            }
        );
    }

    delkey(key: any) {
        this.siteServices.provider_Execute(
            this.pid,
            'DELCATEGORYKEY',
            { CategoryKeyID: key.CategoryKeyID },
            (data) => {
                const ndx = this.curKeyList.findIndex(
                    (x) => x.CategoryKeyID === key.CategoryKeyID
                );
                if (ndx >= 0) {
                    this.curKeyList.splice(ndx, 1);
                }
            }
        );
    }

    savekey(cat: any, key: any) {
        const isnew = !key.CategoryKeyID;
        key.CategoryID = cat;
        this.siteServices.provider_Execute(
            this.pid,
            'SAVECATEGORYKEY',
            key,
            (data) => {
                if (isnew) {
                    this.curKeyList.push(data.TagObject);
                } else {
                    Object.assign(key, data.TagObject);
                }
                key.edited = false;
                this.newKey = null;
            }
        );
    }

    providerImagesEdit(cat: any) {
        this.categoryImages = null;
        this.current_row = cat;
        this.modalRef = this.bsmodalService.show(this.catTemplateRef, {
            class: 'modal-lg',
        });
    }

    selectProvider(provider: any) {
        this.categoryImages = [];
        console.log(this.categoryImages);
        this.current_provider = provider;
        this.siteServices.provider_Execute(
            'CATEGORY',
            'GETPROVIDERCATEGORYIMAGES',
            {
                providerId: this.current_provider.ProviderID,
                categoryId: this.current_row.CategoryID,
            },
            (data) => {
                this.categoryImages = data.TagObject.Result;
                console.log(this.categoryImages);

                /**********************1. IMG************************/
                this.headerIconUploader = new FileUploader({
                    url: '/provider/headerIconUpload/',
                });
                this.headerIconUploader.onErrorItem = (
                    item,
                    response,
                    status,
                    headers
                ) => {
                    this.errstr = 'Hibás feltöltés (' + status + ')';
                    this.isupload = false;
                };
                this.headerIconUploader.onSuccessItem = (
                    item,
                    response,
                    status,
                    headers
                ) => {
                    this.isupload = false;
                    let r = JSON.parse(response);
                    //   location.reload();
                    this.categoryImages = null;
                    // this.selectProvider(provider);
                    console.log(response);
                };
                this.headerIconUploader.onBeforeUploadItem = (fileItem) => {
                    this.errstr = '';
                    this.isupload = true;
                    if (this.current_row.CategoryID)
                        fileItem.alias =
                            this.current_provider.ProviderID +
                            '_' +
                            this.current_row.CategoryID;
                    this.engine[this.current_provider.ProviderID] = {
                        ProviderCode: this.current_provider.ProviderID,
                    };
                };
                this.headerIconUploader.onAfterAddingFile = (fileItem) => {
                    this.errstr = '';
                    this.isupload = true;
                    //   location.reload();
                };
                this.headerIconUploader.options['autoUpload'] = true;
                /**********************1. IMG-END************************/
                /**********************2. IMG************************/
                this.MainCategoryIconFileNameIconUploader = new FileUploader({
                    url: '/provider/MainCategoryIconFileNameIconUpload/',
                });
                this.MainCategoryIconFileNameIconUploader.onErrorItem = (
                    item,
                    response,
                    status,
                    headers
                ) => {
                    this.errstr = 'Hibás feltöltés (' + status + ')';
                    this.isupload = false;
                };
                this.MainCategoryIconFileNameIconUploader.onSuccessItem = (
                    item,
                    response,
                    status,
                    headers
                ) => {
                    this.isupload = false;
                    let r = JSON.parse(response);
                    //   location.reload();
                    this.categoryImages = null;
                    console.log(response);
                };
                this.MainCategoryIconFileNameIconUploader.onBeforeUploadItem = (
                    fileItem
                ) => {
                    this.errstr = '';
                    this.isupload = true;
                    if (this.current_row.CategoryID)
                        fileItem.alias =
                            this.current_provider.ProviderID +
                            '_' +
                            this.current_row.CategoryID;
                    this.engine[this.current_provider.ProviderID] = {
                        ProviderCode: this.current_provider.ProviderID,
                    };
                };
                this.MainCategoryIconFileNameIconUploader.onAfterAddingFile = (
                    fileItem
                ) => {
                    this.errstr = '';
                    this.isupload = true;
                    //   location.reload();
                };
                this.MainCategoryIconFileNameIconUploader.options[
                    'autoUpload'
                ] = true;
                /**********************2. IMG-END************************/
                /**********************3. IMG************************/
                this.MainCategoryImageWhiteFileNameUploader = new FileUploader({
                    url: '/provider/MainCategoryImageWhiteFileNameUpload/',
                });
                this.MainCategoryImageWhiteFileNameUploader.onErrorItem = (
                    item,
                    response,
                    status,
                    headers
                ) => {
                    this.errstr = 'Hibás feltöltés (' + status + ')';
                    this.isupload = false;
                };
                this.MainCategoryImageWhiteFileNameUploader.onSuccessItem = (
                    item,
                    response,
                    status,
                    headers
                ) => {
                    this.isupload = false;
                    let r = JSON.parse(response);
                    //   location.reload();
                    this.categoryImages = null;

                    console.log(response);
                };
                this.MainCategoryImageWhiteFileNameUploader.onBeforeUploadItem =
                    (fileItem) => {
                        this.errstr = '';
                        this.isupload = true;
                        if (this.current_row.CategoryID)
                            fileItem.alias =
                                this.current_provider.ProviderID +
                                '_' +
                                this.current_row.CategoryID;
                        this.engine[this.current_provider.ProviderID] = {
                            ProviderCode: this.current_provider.ProviderID,
                        };
                    };
                this.MainCategoryImageWhiteFileNameUploader.onAfterAddingFile =
                    (fileItem) => {
                        this.errstr = '';
                        this.isupload = true;
                        //   location.reload();
                    };
                this.MainCategoryImageWhiteFileNameUploader.options[
                    'autoUpload'
                ] = true;
                /**********************3. IMG-END************************/
                /**********************4. IMG************************/
                this.MainCategoryImageBlueFileNameUploader = new FileUploader({
                    url: '/provider/MainCategoryImageBlueFileNameUpload/',
                });
                this.MainCategoryImageBlueFileNameUploader.onErrorItem = (
                    item,
                    response,
                    status,
                    headers
                ) => {
                    this.errstr = 'Hibás feltöltés (' + status + ')';
                    this.isupload = false;
                };
                this.MainCategoryImageBlueFileNameUploader.onSuccessItem = (
                    item,
                    response,
                    status,
                    headers
                ) => {
                    this.isupload = false;
                    let r = JSON.parse(response);
                    //   location.reload();
                    this.categoryImages = null;

                    console.log(response);
                };
                this.MainCategoryImageBlueFileNameUploader.onBeforeUploadItem =
                    (fileItem) => {
                        this.errstr = '';
                        this.isupload = true;
                        if (this.current_row.CategoryID)
                            fileItem.alias =
                                this.current_provider.ProviderID +
                                '_' +
                                this.current_row.CategoryID;
                        this.engine[this.current_provider.ProviderID] = {
                            ProviderCode: this.current_provider.ProviderID,
                        };
                    };
                this.MainCategoryImageBlueFileNameUploader.onAfterAddingFile = (
                    fileItem
                ) => {
                    this.errstr = '';
                    this.isupload = true;
                    //   location.reload();
                };
                this.MainCategoryImageBlueFileNameUploader.options[
                    'autoUpload'
                ] = true;
                /**********************4. IMG-END************************/
                /**********************5. IMG************************/
                this.CategoryImageFileNameUploader = new FileUploader({
                    url: '/provider/CategoryImageFileNameUpload/',
                });
                this.CategoryImageFileNameUploader.onErrorItem = (
                    item,
                    response,
                    status,
                    headers
                ) => {
                    this.errstr = 'Hibás feltöltés (' + status + ')';
                    this.isupload = false;
                };
                this.CategoryImageFileNameUploader.onSuccessItem = (
                    item,
                    response,
                    status,
                    headers
                ) => {
                    this.isupload = false;
                    let r = JSON.parse(response);
                    //   location.reload();
                    this.categoryImages = null;

                    console.log(response);
                };
                this.CategoryImageFileNameUploader.onBeforeUploadItem = (
                    fileItem
                ) => {
                    this.errstr = '';
                    this.isupload = true;
                    if (this.current_row.CategoryID)
                        fileItem.alias =
                            this.current_provider.ProviderID +
                            '_' +
                            this.current_row.CategoryID;
                    this.engine[this.current_provider.ProviderID] = {
                        ProviderCode: this.current_provider.ProviderID,
                    };
                };
                this.CategoryImageFileNameUploader.onAfterAddingFile = (
                    fileItem
                ) => {
                    this.errstr = '';
                    this.isupload = true;
                    //   location.reload();
                };
                this.CategoryImageFileNameUploader.options['autoUpload'] = true;
                /**********************5. IMG-END************************/
            }
        );
    }

    editkey(key: any) {
        key.edited = true;
    }
}
